var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex items-center justify-center text-ink-soft"},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"circle-notch","spin":""}}),_vm._v(" Signing out… ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }